<template>
  <button 
    class="theme-toggle" 
    @click="toggleTheme" 
    :aria-label="'Switch to ' + (isDark ? 'light' : 'dark') + ' mode'"
  >
    <div class="toggle-track">
      <div class="toggle-thumb" :class="{ 'is-dark': isDark }">
        <i :class="isDark ? 'bi bi-moon-stars-fill' : 'bi bi-sun-fill'"></i>
      </div>
    </div>
  </button>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const isDark = ref(false);

const toggleTheme = () => {
  isDark.value = !isDark.value;
  const theme = isDark.value ? 'dark' : 'light';
  document.documentElement.setAttribute('data-theme', theme);
  localStorage.setItem('theme', theme);
};

onMounted(() => {
  const currentTheme = document.documentElement.getAttribute('data-theme');
  isDark.value = currentTheme === 'dark';
});
</script>

<style scoped>
.theme-toggle {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
}

.toggle-track {
  width: 54px;
  height: 28px;
  background: var(--accent-soft);
  border: 1px solid var(--border-color);
  border-radius: 999px;
  position: relative;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.toggle-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  background: var(--accent);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.toggle-thumb.is-dark {
  left: 29px;
  background: #fdfdfd;
}

.toggle-thumb i {
  font-size: 0.8rem;
  color: #fff;
  transition: all 0.4s ease;
}

.toggle-thumb.is-dark i {
  color: #1a1a1a;
}

.theme-toggle:hover .toggle-track {
  border-color: var(--accent);
}

.theme-toggle:hover .toggle-thumb {
  transform: scale(1.1);
}
</style>
